// extracted by mini-css-extract-plugin
export default {"verticalContainer":"PolicyFlyCard_verticalContainer__SguIa","verticalContainerSmall":"PolicyFlyCard_verticalContainerSmall__dY7aU","header":"PolicyFlyCard_header__rhWJ+"};